<template>
<div class="">
    <div class="image-wrapper" v-if="item.imgPath">
      <img :src="baseUrl + item.imgPath" />
    </div>
    <div class="image-wrapper" v-else>
      <img :src="getAssetUrl()" />
    </div>

    <div class="card-section">
      <div class="grid-x text-center grid-padding-y">
        <div class="cell">
          <div
            class="font-bold ellipsis"
            style="text-transform: capitalize;"
            :title="item.nameInfo.contentData"
          >
            <span class="card-product-title">
            {{ item.nameInfo.contentData }}
            </span>
          </div>
          <div
            style="display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;"
          > 
            <span class="card-product-description">
            {{ item.descriptionInfo.contentData }}
            <br />
            <br />
            <br />
            </span>
            <br />
            <br />
          </div>

          <div class="" style="    ">
            <!-- <span
                              class="priceOld"
                              style="    
                          color: #7d7d7d;
                          font-size: 0.8125rem;
                          line-height: 1rem;
                          text-decoration: line-through;"
                            >
                              120RMB
                            </span> -->
            <span
              class="card-product-price"
              style="
                          line-height: 1rem;
                          "
            >
              {{ (item.marketPrice || 0).toFixed(2) }} USD
            </span>
            
           
          </div>
        </div>
      </div>
    </div>
  <!-- </router-link> -->

</div>
</template>

<script>
import configService from "@/app/config-service.js";

export default {
  name: "product-card",
  props: {
    item: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      //model: {},

      isValid: false,
      loading: false,
      errored: false,

      isAuthenticated: true,

      cartButton: {
        status: 0
      }
    };
  },
  computed: {
    baseUrl() {
      return configService.baseUrl;
    }
  },
  methods: {
    getAssetUrl(assetName) {
       return assetName ? 
      require("@/assets/images/" + assetName): 
      require("@/assets/images/overlay.png");
    },
    addToCart(){

    }
  },
};
</script>

<style lang="scss">

.card-product-title{
  // font-size: 1.875rem;
  color: 5c5c5c;
    display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card-product-description{
  // font-size: 1.5rem;
  color: 9c9c9c;
    display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card-product-price{
  // font-size: 1.5rem;
  color: #000000;
  font-weight: bold;
}

.card-product {
  transition: all .3s ease;

  .price.red{
    transition: all .3s ease;
  }

  .image-wrapper {
    min-height: 218px;
    img {
      max-height: 218px;
    }
  }
   &:hover,
   &:focus{
  //   color: inherit;
    .price.red{
      font-weight: bold;
    }
   }
}

.product-catalog {
  a.category {
    color: inherit;
    &.subCategoryActive{
      //font-weight: bold;
      //text-decoration: underline;
      background-color: #e1edf8;
    }
  }
}
</style>
